export const UPLOAD_MODE = {
  AUTO: 'auto',
  MANUAL: 'manual',
};

export const ACCEPTED_FILE_TYPES = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx';

export const DEFAULT_BUTTON_TEXT = 'Upload';

export const DEFAULT_BUTTON_CLASS = 'btn cta-outlined-btn';

export const PREVIEW_POSITION = {
  BEFORE: 'before',
  AFTER: 'after',
};

export const DEFAULT_PREVIEW_TEXT = 'view';
